import { render, staticRenderFns } from "./CasePresentation.vue?vue&type=template&id=6e9cd3f7&scoped=true&"
import script from "./CasePresentation.vue?vue&type=script&lang=js&"
export * from "./CasePresentation.vue?vue&type=script&lang=js&"
import style0 from "./CasePresentation.vue?vue&type=style&index=0&id=6e9cd3f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9cd3f7",
  null
  
)

export default component.exports